import React, { useState } from 'react';
import PropTypes from 'prop-types';
// material-ui
import Snackbar from '@material-ui/core/Snackbar';
// common components
import CustomButton from './../Forms/CustomButton/CustomButton';
// css
import './Snackbar.scss';

const CustomSnackbar = ({ snackbar, handleSnackbar }) => {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            className={`CustomSnackbar ${snackbar.varient}`}
            open={snackbar.open}
            autoHideDuration={3600}
            onClose={handleSnackbar}
            message={<span className="message">{snackbar.message}</span>}
            action={
                <CustomButton
                    iconName="cross"
                    iconOnly
                    onClick={handleSnackbar}
                />
            }
        />
    );
}

CustomSnackbar.propTypes = {
    // snackbarOpen: PropTypes.bool,
    // message: PropTypes.string,
    // handleClose: PropTypes.func,
    // varient: PropTypes.string
};

CustomSnackbar.defaultProps = {
    // snackbarOpen: false,
    // message: '',
    // handleClose: () => { },
    // varient: ''
};

export default CustomSnackbar;


// WEBPACK FOOTER //
// ./common/Snackbar/Snackbar.js